// @flow @jsx h
import { Component, h } from 'preact'
import { SerumResponsivePicture } from '@nrk/dh-feature-components'
import { bem } from '@nrk/dh-utils'
import { HtmlContent } from '../HtmlContent'
import { connect } from '../../../lib/provider'
import sanitizeHtml from 'sanitize-html'

/* types */
import type { FeedItem } from '../types'

/* styles */
import styles from './index.css'

const sanitizeConfig = {
  allowedTags: ['b', 'i', 'em', 'strong', 'a', 'p'],
  allowedAttributes: {
    'a': ['href']
  }
}

const imageIds = {
  'christina.quist@vg.no': '1.8050597',
  'oystein.milli@vg.no': '1.14266646',
  'per.oyvind.fange@nrk.no': '1.13230727',
  'lars.satren@nrk.no': '1.14222657'
}

type Props = {
  feedItem: FeedItem,
  initiallyOpen: boolean,
  sendGaEvent: any => void
}
type State = {
  expanded: boolean,
  dirty: boolean
}

class _Question extends Component<Props, State> {
  bodyElm: HTMLElement

  constructor (props: Props) {
    super()
    this.state = {
      expanded: !!props.initiallyOpen,
      dirty: false
    }
  }

  componentDidMount () {
    this.bodyElm.style.setProperty('--question-max-height', this.bodyElm.scrollHeight + 'px')
  }

  componentDidUpdate () {
    this.bodyElm.style.setProperty('--question-max-height', this.bodyElm.scrollHeight + 'px')
  }

  handleToggle = (event) => {
    event.preventDefault()
    this.setState({ expanded: !this.state.expanded, dirty: true })
    this.props.sendGaEvent &&
    this.props.sendGaEvent({
      action: this.state.expanded ? 'SHOW_ANSWER' : 'HIDE_ANSWER',
      label: this.props.feedItem.data.text
    })
  }

  renderTitle (userId: string) {
    if (userId.indexOf('nrk.no') !== -1) {
      return 'Journalist i NRK'
    } else {
      return 'Journalist i VG'
    }
  }

  render () {
    const { feedItem } = this.props
    const { expanded, dirty } = this.state

    return <div key={feedItem.id} class={styles.feedItem} ref={elm => (this.elm = elm)} tabIndex='-1'>
      <a
        class={bem(styles.feedItem__question, { expanded })}
        href={'./?id=' + feedItem.id}
        aria-expanded={this.state.expanded ? 'true' : 'false'}
        aria-controls={`body_${feedItem.id}`}
        role='button'
        onClick={this.handleToggle}>
        <HtmlContent content={sanitizeHtml(feedItem.data.text, sanitizeConfig)} type={'span'} />
        <div class={styles.feedItem__questionFrom}>&ndash; {feedItem.data.fromUserName.split('@')[0].toLowerCase()}</div>
      </a>
      <div
        id={`body_${feedItem.id}`}
        class={bem(styles.feedItem__body, { expanded, dirty })}
        ref={elm => (this.bodyElm = elm)}>
        <div class={styles.feedItem__bodyContent}>
          {/* <div class={styles.feedItem__questionFrom}>
            Innsender: {feedItem.data.fromUserName}
          </div> */}
          {feedItem.answers.map(answer => {
            return <div key={answer.answerId} class={styles.feedItem__answer}>
              <div class={styles.feedItem__answerText}>
                <HtmlContent type={'div'} content={sanitizeHtml(answer.text, sanitizeConfig)} />
              </div>
              <div class={styles.feedItem__answerFrom}>
                <div class={styles.feedItem__answerFromAuthor}>
                  {answer.fromUserName} <br />
                  {this.renderTitle(answer.fromUserId)}
                </div>
                <div className={styles.feedItem__answerFromImage}>
                  <SerumResponsivePicture id={imageIds[answer.fromUserId] || '1.8050600'} quality={0.8} ratio={'1:1'} />
                </div>
              </div>
            </div>
          })
          }
        </div>
      </div>
    </div>
  }
}

const connector = connect()
export const Question = connector(_Question)
